import styled from '@emotion/styled';
import { Text } from 'components/core/text';
import { useTranslations } from 'use-intl';

const NpExclusionList = styled.ul`
  list-style-type: disc;
  padding-left: 1em;
  display: flex;
  flex-direction: column;
  gap: 1.125rem;
  @media (--mobile) {
    gap: 1rem;
  }
`;

const ExclusionCriterion = styled.li`
  color: var(--neutral-gray-6, #292927);
  font-feature-settings:
    'liga' off,
    'clig' off;
  font-family: 'sofiaprosoft';
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 27px */
`;

const ExclusionText = styled(Text)``;

ExclusionText.defaultProps = {
  color: 'darkBendBlue',
  variant: 'subheadline2',
  bold: true,
};

const NpBody = styled.div`
  display: flex;
  max-width: 800px;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`;
const NpElement = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

const ExclusionList = [
  'Active command hallucinations, severe thought disorganization',
  'Neurocognitive disorder who have severe memory or functioning difficulties',
  'BMI of less than 18 due to an eating disorder',
  'Custody evaluations or court ordered evaluations',
  'Tuberous Sclerosis Complex (TSC)',
  'Severe Intellectual Disabilities',
  'Non-verbal Autism Spectrum Disorder (ASD)',
  'Severe Epilepsy Syndromes (e.g., Dravet Syndrome)',
  'Progressive Neurological Conditions (e.g., Batten Disease)',
  'Severe Psychogenic Non-Epileptic Seizures (PNES)',
  'Photosensitive Epilepsy and Screen Risks i.e. sensitivity to Flashing/Flickering Lights, Bright/High-Contrast Screens, Rapid Visual Changes, etc.',
  'Extremely limited access to technology',
  'Severe impulsivity or aggression impairing ability to engage in virtual testing',
  'Testing for fine motor coordination',
];
export const NpExclusions = () => {
  const t = useTranslations('RelationshipPage');
  return (
    <NpBody>
      <NpElement>
        <NpExclusionList>
          {ExclusionList.map((exclusion, index) => (
            <ExclusionCriterion key={index}>{exclusion}</ExclusionCriterion>
          ))}
        </NpExclusionList>
      </NpElement>
    </NpBody>
  );
};
